import { Card, Typography, Link } from '@mui/material';

interface RegulationFeedItemProps {
  readonly title: string;
  readonly link: string;
  readonly description?: string;
}
export default function RegulationFeedItem({
  title,
  link,
  description,
}: RegulationFeedItemProps) {
  return (
    <Card sx={{ padding: 2 }} variant='outlined'>
      <Typography
        variant='h5'
        component={Link}
        href={link}
        target='_blank'
        rel='noopener noreferrer'
        underline='none'
        sx={{
          color: 'text.primary',
          '&:hover': { color: 'primary.main' },
        }}
      >
        {title}
      </Typography>
      <Typography variant='body2' sx={{ color: 'text.secondary' }}>
        {description}
      </Typography>
    </Card>
  );
}
